import React from "react";
import { TagPicker } from "rsuite";

interface Props {
  data: any;
  label?: string;
  style?: { width: number };
  onChange?: any;
  displayLabel?: boolean;
  defaultValue?: number[];
  isValidate?: boolean;
  value?: any;
  placeholder?: String;
  displayCount?: boolean;
  onSearch?: any;
  onClean?: any;
  disabled?: boolean;
  customNoFoundMsg?: string;
}

export const EPTagPicker: React.FC<Props> = ({
  label,
  isValidate,
  data,
  value,
  defaultValue,
  placeholder,
  onChange,
  displayLabel,
  displayCount,
  onSearch,
  onClean,
  disabled,
  customNoFoundMsg,
  style = {
    width: "100%",
    height: "42px",
  },
}) => {
  let dataList: any;

  if (label === "Skill") {
    dataList = data?.map((item: any) => ({
      label: item.TechnologyName,
      value: item.TechnologyID,
    }));
  } else if (label === "Project") {
    dataList = data?.map((item: any) => ({
      label: item?.ProjectName,
      value: item?.ProjectId,
    }));
  } else if (label === "EmailEvent") {
    dataList = data?.map((item: any) => ({
      label: item?.Name,
      value: item?.Id,
    }));
  } else if (label === "Designation") {
    dataList = data?.map((item: any) => ({
      label: item.DesignationName,
      value: item.DesignationId,
    }));
  } else if (label === "Technology") {
    dataList = data?.map((item: any) => ({
      label: item.Name,
      value: item.Id,
    }));
  } else if (label === "Round") {
    dataList = data?.map((item: any) => ({
      label: item.RoundName,
      value: item.RoundId,
    }));
  } else if (label === "Interviewer") {
    dataList =
      data &&
      data?.map((item: any) => ({
        label: `${item.FirstName} ${item.LastName ? item.LastName : ""}`,
        value: item.EmployeeId,
      }));
  } else if (label === "Priority") {
    dataList = data?.map((item: any) => ({
      label: item.Priority,
      value: item.PriorityId,
    }));
  } else if (label === "Raised By") {
    dataList = data?.map((item: any) => ({
      label: item.EmployeeName,
      value: item.EmployeeCode,
    }));
  } else if (label === "EditSkill") {
    dataList = data?.map((item: any) => ({
      label: item.TechnologyName,
      value: item.TechnologyID,
    }));
  } else if (label === "Mode of work") {
    dataList = data?.map((item: any) => ({
      label: item.ModeOfWork,
      value: item.ModeOfWorkId,
    }));
  } else if (label === "Current designation") {
    dataList = data?.map((item: any) => ({
      label: item,
      value: item,
    }));
  } else if (label === "Education level") {
    dataList = data?.map((item: any) => ({
      label: item.DegreeName,
      value: item.Id,
    }));
  } else if (label === "Candidate status") {
    dataList = data?.map((item: any) => ({
      label: item.StatusName,
      value: item.StatusId,
    }));
  } else if (label === "EducationDegree") {
    dataList = data?.map((item: any) => ({
      label: item.DegreeName,
      value: item.Id,
    }));
  } else if (label === "Status") {
    dataList = data?.map((item: any) => ({
      label: item.StatusName,
      value: item.StatusId,
    }));
  } else if (label === "Source") {
    dataList = data?.map((item: any) => ({
      label: item.SourceName,
      value: item.SourceId,
    }));
    // } else if (label === "Candidate name") {
    //   dataList = data?.map((item: any) => ({
    //     label: `${item.FirstName} ${item.LastName ? item.LastName : ""}`,
    //     value: item.CandidateId,
    //   }));
  } else if (label === "Candidate name") {
    dataList = data?.map((FullName: any) => ({
      label: FullName,
      value: FullName,
    }));
  } else if (label === "Candidate Email") {
    dataList = data?.map((email: any) => ({
      label: email,
      value: email,
    }));
  } else if (label === "RecruitmentReport") {
    dataList = data?.map((item: any) => ({
      label: `${item.FirstName} ${item.LastName ? item.LastName : ""}`,
      value: item.EmployeeId,
    }));
  } else if (label === "LeadTimeDays") {
    dataList = data?.map((item: any) => ({
      label: item.LeadTimeDays,
      value: item.LeadTimeDays,
    }));
    const uniqueValues: any = dataList.reduce((unique: any[], item: any) => {
      if (!unique.some((i) => i.label === item.label)) {
        unique.push(item);
      }
      return unique;
    }, []);
    dataList = uniqueValues;
  } else if (label === "RoleIds") {
    dataList = data?.map((item: any) => ({
      label: item.PageName,
      value: item.RoleId,
    }));
  } else if (label === "Candidate Resume") {
    dataList = data?.map((item: any) => ({
      label: item.FullName,
      value: item.ProfilePath,
    }));
  } else if (label === "Recipients(TO)") {
    dataList = data?.map((item: any) => ({
      label: item.Name,
      value: item.Id,
    }));
  } else if (label === "Recipients(CC)") {
    dataList = data?.map((item: any) => ({
      label: item.Name,
      value: item.Id,
    }));
  } else if (label === "DesignationList") {
    dataList = data?.map((item: any) => ({
      label: item?.DesignationName,
      value: item?.DesignationId,
    }));
  } else if (label === "Role") {
    dataList = data?.map((item: any) => ({
      label: item.Name,
      value: item.RoleId,
    }));
  }
  return (
    <TagPicker
      data={dataList}
      style={style}
      value={value}
      placeholder={displayLabel ? label : placeholder}
      onChange={onChange}
      disabled={disabled}
      className={
        value?.length === 0 && isValidate ? "border border-danger" : ""
      }
      renderValue={
        displayCount && value && value.length > 1
          ? () => {
              if (value.length >= 1) return `${value.length} Items Selected`;
            }
          : undefined
      }
      onClean={onClean}
      // virtualized
      onSearch={onSearch}
      renderMenu={(menu) => {
        if (dataList.length === 0 && customNoFoundMsg) {
          return <div className="rs-picker-none">{customNoFoundMsg}</div>;
        }
        return menu;
      }}
    />
  );
};
